/*
 * Copyright (c) 2026 Klaus Reimer
 * SPDX-License-Identifier: MIT
 */

/**
 * Base class for actions.
 */
export abstract class Action {
    // Empty for now
}
